<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vs-tabs>
    <vs-tab label="전체">
      <InsightTotal/>
    </vs-tab>
    <vs-tab label="출석부">
      <InsightAttend/>
    </vs-tab>
    <vs-tab label="프로젝트">
      <InsightProject/>
    </vs-tab>
    <!-- <vs-tab label="결과물">
      <InsightReport/>
    </vs-tab>
    <vs-tab label="시험">
      <InsightTest/>
    </vs-tab> -->
  </vs-tabs>
</template>

<script>

// Cell Renderer
import InsightTotal from "./insight/InsightTotal.vue"
import InsightAttend from "./insight/InsightAttend.vue"
import InsightProject from "./insight/InsightProject.vue"
// import InsightTest from "./insight/InsightTest.vue"
// import InsightReport from "./insight/InsightReport.vue"
// import moduleInsight from '@/store/insight/moduleInsight.js'


export default {
  components: {
    InsightTotal,
    InsightAttend,
    InsightProject,
  },
  // watch:{
  // },
  // methods: {
  // },
  // created() {
  //   console.log('test')
  // }
}

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
